import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login/login";
import ForgotPassword from "./pages/login/forgot-password";
import ResetPassword from "./pages/login/reset-password";
import Main from "./layout/main/main";
import Toast from "./components/toast/toast";

function App() {
  return (
    <Router>
      <Toast />

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/*" element={<Main />} />
      </Routes>
    </Router>
  );
}

export default App;
